import { useEffect, useMemo, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import { API_URL } from '../../store';
import { Ic } from '../icons';
import { useFedStore } from '../store';
import { demoForTournament } from './demo';

const DEMO_ENABLED = process.env.NODE_ENV !== 'production'
  || process.env.REACT_APP_MATCH_DEMO_ENABLED === 'true';

const MATCH_TEXT = {
  ru: { scheduled:'СКОРО',finished:'ЗАВЕРШЁН',auto:'Игровой сервер',upload:'Протокол',manual:'Оператор',summary:'Счёт, составы и статистика',open:'Открыть',liveNow:'МАТЧ ИДЁТ СЕЙЧАС',round:'раунд',gameTime:'время',watch:'Смотреть матч и статистику',kills:'Убийства',deaths:'Смерти',assists:'Помощь',gold:'Золото',rating:'Рейтинг',headshots:'Headshots',closePlayer:'Закрыть карточку игрока',player:'ИГРОК',currentForm:'ФОРМА В ТЕКУЩЕМ МАТЧЕ',great:'Отличная игра',stable:'Стабильная игра',comeback:'Есть пространство для камбэка',autoNote:'Показатели публикуются оператором матча.',team:'КОМАНДА',currentScore:'ТЕКУЩИЙ СЧЁТ',match:'Матч',players:'Игроки',maps:'Карты',games:'Игры',events:'Ход матча',watchLive:'Смотреть эфир',allMatches:'Все матчи',matchCard:'КАРТОЧКА МАТЧА',choose:'Выберите ниже, что хотите посмотреть.',sections:'Разделы матча',mapLive:'Идёт сейчас',mapDone:'Завершена',mapNext:'Следующая',broadcast:'Трансляция матча',broadcastNote:'Здесь будет встроен Twitch, YouTube или плеер федерации.',openLive:'Открыть эфир',updates:'Данные обновляются',tournamentMatches:'МАТЧИ ТУРНИРА',headline:'Смотрите игру в реальном времени',intro:'Здесь собраны трансляция, текущий счёт и статистика игроков.',online:'Обновляется сейчас',demo:'Демонстрационный режим',other:'Другие матчи',otherHint:'Нажмите на матч, чтобы открыть подробности.',score:'Счёт',noEvents:'События матча пока не опубликованы',empty:'Матчи этого турнира пока не опубликованы.' },
  kz: { scheduled:'ЖАҚЫНДА',finished:'АЯҚТАЛДЫ',auto:'Ойын сервері',upload:'Хаттама',manual:'Оператор',summary:'Есеп, құрамдар және статистика',open:'Ашу',liveNow:'МАТЧ ҚАЗІР ӨТІП ЖАТЫР',round:'раунд',gameTime:'уақыт',watch:'Матч пен статистиканы көру',kills:'Килл',deaths:'Өлім',assists:'Ассист',gold:'Алтын',rating:'Рейтинг',headshots:'Хедшоттар',closePlayer:'Ойыншы карточкасын жабу',player:'ОЙЫНШЫ',currentForm:'АҒЫМДАҒЫ МАТЧТАҒЫ ФОРМА',great:'Керемет ойын',stable:'Тұрақты ойын',comeback:'Камбэк жасауға мүмкіндік бар',autoNote:'Көрсеткіштерді матч операторы жариялайды.',team:'КОМАНДА',currentScore:'АҒЫМДАҒЫ ЕСЕП',match:'Матч',players:'Ойыншылар',maps:'Карталар',games:'Ойындар',events:'Матч барысы',watchLive:'Эфирді көру',allMatches:'Барлық матчтар',matchCard:'МАТЧ КАРТОЧКАСЫ',choose:'Төменнен көргіңіз келетін бөлімді таңдаңыз.',sections:'Матч бөлімдері',mapLive:'Қазір өтіп жатыр',mapDone:'Аяқталды',mapNext:'Келесі',broadcast:'Матч трансляциясы',broadcastNote:'Мұнда Twitch, YouTube немесе федерация плеері көрсетіледі.',openLive:'Эфирді ашу',updates:'Деректер көзі',tournamentMatches:'ТУРНИР МАТЧТАРЫ',headline:'Ойынды нақты уақытта бақылаңыз',intro:'Мұнда трансляция, ағымдағы есеп және ойыншылар статистикасы бар.',online:'Қазір жаңартылуда',demo:'Демонстрациялық режим',other:'Басқа матчтар',otherHint:'Толық ақпаратты ашу үшін матчты басыңыз.',score:'Есеп',noEvents:'Матч оқиғалары әлі жарияланған жоқ',empty:'Бұл турнирдің матчтары әлі жарияланған жоқ.' },
};
const useMatchText = () => useFedStore((state) => MATCH_TEXT[state.lang] || MATCH_TEXT.ru);

const mapsWordRu = (count) => (count % 10 === 1 && count % 100 !== 11 ? 'карты' : 'карт');
const LEADERS_TEXT = {
  ru: { sections:'Разделы турнира', matchesTab:'Матчи', playersTab:'Игроки турнира', title:'Статистика игроков', hint:'Сумма по всем сыгранным картам турнира. Обновляется после каждой карты.', matches:'Матчей', maps:'Карт', player:'Игрок', mapsCol:'Карты', rating:'Рейтинг', loading:'Загружаем статистику…', empty:'Статистика появится после первой сыгранной карты.', matchMvp:'MVP матча', tournamentMvp:'MVP турнира', mvpRule:(count) => `Лучший рейтинг среди игроков, сыгравших не меньше ${count} ${mapsWordRu(count)}` },
  kz: { sections:'Турнир бөлімдері', matchesTab:'Матчтар', playersTab:'Турнир ойыншылары', title:'Ойыншылар статистикасы', hint:'Турнирдің барлық ойналған карталары бойынша жиынтық. Әр картадан кейін жаңартылады.', matches:'Матчтар', maps:'Карталар', player:'Ойыншы', mapsCol:'Карталар', rating:'Рейтинг', loading:'Статистика жүктелуде…', empty:'Статистика алғашқы ойналған картадан кейін пайда болады.', matchMvp:'Матч MVP', tournamentMvp:'Турнир MVP', mvpRule:(count) => `Кемінде ${count} карта ойнаған ойыншылар арасындағы ең жоғары рейтинг` },
};
const useLeadersText = () => useFedStore((state) => LEADERS_TEXT[state.lang] || LEADERS_TEXT.ru);
const fixed = (value, digits) => (value === null || value === undefined ? '—' : Number(value).toFixed(digits));
const ratingTone = (rating) => (rating === null || rating === undefined ? '' : rating >= 1.15 ? ' hot' : rating < 0.85 ? ' cold' : '');
const playerKey = (player) => player?.steam_id || player?.nick;

function MvpBanner({ label, player, note }) {
  const L = useLeadersText();
  const stats = [[L.rating, fixed(player.rating, 2)], ['K–D', `${player.kills ?? 0}–${player.deaths ?? 0}`], ['ADR', fixed(player.adr, 1)]];
  if (player.maps) stats.push([L.mapsCol, player.maps]);
  return <div className="mc-mvp">
    <span className="mc-mvp-badge" aria-hidden="true"><Ic name="crown" size={22} /></span>
    <div className="mc-mvp-main"><span>{label}</span><b>{player.nick}</b>{player.team && <small>{player.team}</small>}{note && <p>{note}</p>}</div>
    <div className="mc-mvp-stats">{stats.map(([name, value]) => <div key={name}><span>{name}</span><b>{value}</b></div>)}</div>
  </div>;
}

function TournamentPlayers({ tournamentKey }) {
  const L = useLeadersText();
  const [data, setData] = useState(null);
  const etag = useRef('');

  useEffect(() => {
    let active = true;
    const load = async () => {
      try {
        const headers = etag.current ? { 'If-None-Match': etag.current } : {};
        const res = await fetch(`${API_URL}/match-center/tournaments/${encodeURIComponent(tournamentKey)}/players`, { headers });
        if (res.status === 304 || !res.ok) return;
        const json = await res.json();
        if (active && Array.isArray(json.players)) {
          etag.current = res.headers.get('ETag') || '';
          setData(json);
        }
      } catch (_) { /* Keep the last loaded table visible. */ }
    };
    etag.current = ''; setData(null); load();
    const timer = window.setInterval(load, 15000);
    return () => { active = false; window.clearInterval(timer); };
  }, [tournamentKey]);

  const players = data?.players || [];
  const mvpKey = playerKey(data?.mvp);
  return <section className="mc-leaders">
    <header className="mc-leaders-head">
      <div><h3>{L.title}</h3><p>{L.hint}</p></div>
      {data?.maps > 0 && <small>{L.matches}: {data.matches} · {L.maps}: {data.maps}</small>}
    </header>
    {data?.mvp && <MvpBanner label={L.tournamentMvp} player={data.mvp} note={L.mvpRule(data.mvp_min_maps)} />}
    {players.length ? <div className="mc-leaders-scroll"><table>
      <thead><tr><th className="player">{L.player}</th><th className="opt">{L.mapsCol}</th><th>K</th><th>D</th><th className="opt">A</th><th className="opt">K/D</th><th>ADR</th><th className="opt">HS%</th><th>{L.rating}</th></tr></thead>
      <tbody>{players.map((player, index) => <tr key={player.steam_id || player.nick} className={index < 3 ? 'top' : undefined}>
        <td className="player"><div className="mc-leader-name"><i>{index + 1}</i><div><b>{player.nick}{playerKey(player) === mvpKey && <em className="mc-mvp-tag">MVP</em>}</b>{player.team && <span>{player.team}</span>}</div></div></td>
        <td className="opt">{player.maps}</td><td>{player.kills}</td><td>{player.deaths}</td><td className="opt">{player.assists}</td>
        <td className="opt">{fixed(player.kd, 2)}</td><td>{fixed(player.adr, 1)}</td><td className="opt">{fixed(player.hs, 1)}%</td>
        <td className={`rating${ratingTone(player.rating)}`}>{fixed(player.rating, 2)}</td>
      </tr>)}</tbody>
    </table></div> : <div className="mc-empty">{data ? L.empty : L.loading}</div>}
  </section>;
}

const progressText = (match, T) => {
  if (match.discipline === 'mlbb') return [match.current_map, match.game_time ? `${T.gameTime} ${match.game_time}` : ''].filter(Boolean).join(' · ');
  return [match.current_map, match.round ? `${T.round} ${match.round}` : ''].filter(Boolean).join(' · ');
};

function TeamBadge({ team }) {
  return <span className="mc-team-badge" aria-hidden="true">{team?.tag || team?.name?.slice(0, 3)}</span>;
}

function MatchCard({ match, onOpen }) {
  const T = useMatchText();
  const [a, b] = match.teams || [];
  return (
    <button className="mc-match-card" onClick={() => onOpen(match)}>
      <span className="mc-match-meta"><b className={`mc-status ${match.status}`}>{match.status === 'live' ? 'LIVE' : T[match.status] || match.status}</b><span>{match.stage}</span><span>BO{match.best_of}</span></span>
      <span className="mc-match-team"><TeamBadge team={a} /><strong>{a?.name}</strong><b>{a?.maps ?? a?.score ?? 0}</b></span>
      <span className="mc-match-team"><TeamBadge team={b} /><strong>{b?.name}</strong><b>{b?.maps ?? b?.score ?? 0}</b></span>
      <span className="mc-match-foot"><span>{match.status === 'live' ? `${progressText(match, T) || T.match} · ${a?.score ?? 0}:${b?.score ?? 0}` : match.mvp ? `MVP · ${match.mvp.nick} · ${fixed(match.mvp.rating, 2)}` : T.summary}</span><b>{T.open} <Ic name="chevR" size={16} /></b></span>
    </button>
  );
}

function LiveSpotlight({ match, onOpen }) {
  const T = useMatchText();
  const [a, b] = match.teams || [];
  return <section className="mc-spotlight">
    <div className="mc-spotlight-top"><span className="mc-live-pill"><i />{T.liveNow}</span><span>{match.stage} · BO{match.best_of}</span></div>
    <div className="mc-spotlight-score">
      <div><TeamBadge team={a} /><strong>{a?.name}</strong></div>
      <p><b>{a?.score ?? 0}</b><i>:</i><b>{b?.score ?? 0}</b><small>{progressText(match, T) || `BO${match.best_of}`}</small></p>
      <div><TeamBadge team={b} /><strong>{b?.name}</strong></div>
    </div>
    <button className="mc-watch-button" onClick={() => onOpen(match)}><Ic name="video" size={19} />{T.watch}<Ic name="chevR" size={18} /></button>
  </section>;
}

function ScoreHero({ match }) {
  const T = useMatchText();
  const [a, b] = match.teams || [];
  return <div className="mc-score-hero">
    <div className="mc-score-side"><TeamBadge team={a} /><strong>{a?.name}</strong></div>
    <div className="mc-score-mid"><span className={`mc-status ${match.status}`}>{match.status === 'live' ? 'LIVE' : T[match.status]}</span><b>{a?.maps ?? 0}<i>:</i>{b?.maps ?? 0}</b><small>{progressText(match, T) || `BO${match.best_of}`}</small></div>
    <div className="mc-score-side right"><TeamBadge team={b} /><strong>{b?.name}</strong></div>
  </div>;
}

function PlayerModal({ player, team, discipline, onClose }) {
  const T = useMatchText();
  const closeRef = useRef(null);
  useEffect(() => {
    const previous = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    closeRef.current?.focus();
    const key = (event) => { if (event.key === 'Escape') onClose(); };
    window.addEventListener('keydown', key);
    return () => { document.body.style.overflow = previous; window.removeEventListener('keydown', key); };
  }, [onClose]);
  if (!player) return null;
  const mlbb = discipline === 'mlbb';
  const kd = player.deaths ? (player.kills / player.deaths).toFixed(2) : player.kills;
  const stats = [
    [T.kills, player.kills ?? '—'], [T.deaths, player.deaths ?? '—'], [T.assists, player.assists ?? '—'],
    ['K/D', kd], [mlbb ? T.gold : 'ADR', mlbb ? player.gold?.toLocaleString() : player.adr],
    [mlbb ? 'KDA' : T.headshots, mlbb ? ((player.kills + player.assists) / Math.max(1, player.deaths)).toFixed(2) : `${player.hs ?? 0}%`],
  ];
  return createPortal(<div className="mc-player-modal-backdrop" role="presentation" onMouseDown={(event) => { if (event.target === event.currentTarget) onClose(); }}>
    <section className={`mc-player-modal team-${player.team}`} role="dialog" aria-modal="true" aria-labelledby="mc-player-name">
      <button ref={closeRef} className="mc-player-close" onClick={onClose} aria-label={T.closePlayer}>×</button>
      <div className="mc-player-grab" aria-hidden="true" />
      <header className="mc-player-profile">
        <div className="mc-player-avatar"><span>{(player.nick || '?').slice(0,2).toUpperCase()}</span><i /></div>
        <div><span>{T.player} · {team?.tag}</span><h2 id="mc-player-name">{player.nick}</h2><p>{[team?.name, player.hero].filter(Boolean).join(' · ')}</p></div>
        <div className="mc-player-rating"><span>{T.rating}</span><b>{player.rating ?? '—'}</b></div>
      </header>
      <div className="mc-player-form"><span>{T.currentForm}</span><div><i style={{width:`${Math.min(100, Math.max(12, (Number(player.rating) || 0) / 1.5 * 100))}%`}} /></div><small>{Number(player.rating) >= 1.2 ? T.great : Number(player.rating) >= 1 ? T.stable : T.comeback}</small></div>
      <div className="mc-player-stat-grid">{stats.map(([label,value]) => <div key={label}><span>{label}</span><b>{value ?? '—'}</b></div>)}</div>
      <div className="mc-player-modal-note"><Ic name="info" size={17} /><span>{T.autoNote}</span></div>
    </section>
  </div>, document.body);
}

function StatsTable({ match }) {
  const T = useMatchText();
  const mlbb = match.discipline === 'mlbb';
  const [selectedPlayer, setSelectedPlayer] = useState(null);
  const teams = match.teams || [];
  const metrics = mlbb ? [['kills','K'],['deaths','D'],['assists','A'],['gold',T.gold],['rating',T.rating]] : [['kills','K'],['deaths','D'],['assists','A'],['adr','ADR'],['rating',T.rating]];
  const value = (player, key) => key === 'gold' ? (player[key]?.toLocaleString() ?? '—') : (player[key] ?? '—');
  const TeamPanel = ({ index, right = false }) => {
    const players = (match.players || []).filter((player) => player.team === index);
    const team = teams[index] || {};
    return <section className={`mc-roster-panel team-${index}${right ? ' right' : ''}`}>
      <header><TeamBadge team={team} /><div><span>{T.team} {index + 1}</span><h3>{team.name}</h3></div><b>{team.score ?? 0}</b></header>
      <div className="mc-roster-labels">{right && metrics.map(([key,label])=><span className={`metric-${key}`} key={label}>{label}</span>)}<span className="player-label">{T.player}</span>{!right && metrics.map(([key,label])=><span className={`metric-${key}`} key={label}>{label}</span>)}</div>
      <div className="mc-roster-body">{players.map((player) => <button type="button" className="mc-roster-row" onClick={() => setSelectedPlayer(player)} aria-label={`${T.open} ${player.nick}`} key={`${index}-${player.nick}`}>
        {right && metrics.map(([key])=><strong className={`metric-${key}${key === 'rating' ? ' rating' : ''}`} key={key}>{value(player,key)}</strong>)}
        <span className="mc-roster-player">{!right && <i className={`mc-team-dot t${index}`} />}<b>{player.nick}</b>{right && <i className={`mc-team-dot t${index}`} />}</span>
        {!right && metrics.map(([key])=><strong className={`metric-${key}${key === 'rating' ? ' rating' : ''}`} key={key}>{value(player,key)}</strong>)}
      </button>)}</div>
    </section>;
  };
  const [a,b] = teams;
  return <><div className="mc-versus-stats">
    <TeamPanel index={0} />
    <div className="mc-versus-center" aria-label={`${T.score} ${a?.score || 0}:${b?.score || 0}`}>
      <span>{T.currentScore}</span><div><b>{a?.score ?? 0}</b><i>:</i><b>{b?.score ?? 0}</b></div><strong>{match.current_map || `BO${match.best_of}`}</strong><small>{match.discipline === 'mlbb' ? (match.game_time ? `${T.gameTime} ${match.game_time}` : T.match) : (match.round ? `${match.round} ${T.round}` : T.match)}</small>
    </div>
    <TeamPanel index={1} right />
  </div>{selectedPlayer && <PlayerModal player={selectedPlayer} team={teams[selectedPlayer.team]} discipline={match.discipline} onClose={() => setSelectedPlayer(null)} />}</>;
}

function MatchDetail({ match, onBack }) {
  const T = useMatchText();
  const L = useLeadersText();
  const [tab, setTab] = useState('stats');
  const tabs = [['stats',T.players],['maps',match.discipline === 'mlbb' ? T.games : T.maps],['events',T.events],['stream',T.watchLive]];
  const [a, b] = match.teams || [];
  const publicEvents = (match.events || []).filter((event) => event.payload?.text);
  return <section className="mc-detail">
    <button className="mc-back" onClick={onBack}><Ic name="chevR" size={15} style={{ transform: 'rotate(180deg)' }} />{T.allMatches}</button>
    <div className="mc-detail-title"><span>{T.matchCard}</span><h2>{match.title}</h2><p>{T.choose}</p></div>
    <ScoreHero match={match} />
    {match.mvp && <MvpBanner label={L.matchMvp} player={match.mvp} />}
    {match.status === 'live' && <div className="mc-live-score"><span>{a?.tag}</span><b>{a?.score}<i>:</i>{b?.score}</b><span>{b?.tag}</span></div>}
    <div className="mc-tabs" role="tablist" aria-label={T.sections}>{tabs.map(([key,label]) => <button key={key} role="tab" aria-selected={tab === key} className={tab === key ? 'on' : ''} onClick={() => setTab(key)}>{label}</button>)}</div>
    {tab === 'stats' && <StatsTable match={match} />}
    {tab === 'maps' && <div className="mc-map-grid">{(match.maps || []).map((map) => <div key={map.name} className={map.status}><span>{map.name}</span><b>{map.a ?? '—'} : {map.b ?? '—'}</b><small>{map.status === 'live' ? T.mapLive : map.status === 'finished' ? T.mapDone : T.mapNext}</small></div>)}</div>}
    {tab === 'events' && <div className="mc-events">{publicEvents.length ? publicEvents.map((event) => <div key={event.id || event.external_id}><span /><p>{event.payload.text}</p></div>) : <div><p>{T.noEvents}</p></div>}</div>}
    {tab === 'stream' && <div className="mc-stream"><Ic name="video" size={32} /><strong>{T.broadcast}</strong><p>{T.broadcastNote}</p>{match.stream_url && <a href={match.stream_url} target="_blank" rel="noreferrer">{T.openLive}</a>}</div>}
    <div className="mc-source"><span className={`mc-source-dot ${match.source_mode}`} /><span>{T.updates}: <b>{T[match.source_mode]}</b></span></div>
  </section>;
}

export default function MatchCenter({ tournamentKey, discipline = 'cs2' }) {
  const T = useMatchText();
  const fallback = useMemo(
    () => DEMO_ENABLED ? demoForTournament(tournamentKey, discipline) : [],
    [tournamentKey, discipline],
  );
  const L = useLeadersText();
  const [matches, setMatches] = useState(fallback);
  const [selected, setSelected] = useState(null);
  const [online, setOnline] = useState(false);
  const [view, setView] = useState('matches');
  const listEtag = useRef('');
  const detailEtag = useRef('');

  useEffect(() => {
    let active = true;
    const load = async () => {
      try {
        const headers = listEtag.current ? { 'If-None-Match': listEtag.current } : {};
        const res = await fetch(`${API_URL}/match-center/matches?tournament=${encodeURIComponent(tournamentKey)}`, { headers });
        if (res.status === 304) { if (active) setOnline(true); return; }
        if (!res.ok) throw new Error();
        const data = await res.json();
        if (active && Array.isArray(data.matches)) {
          listEtag.current = res.headers.get('ETag') || '';
          setMatches(data.matches.length || !DEMO_ENABLED ? data.matches : fallback);
          setOnline(true);
        }
      } catch (e) { if (active) setOnline(false); }
    };
    listEtag.current = ''; detailEtag.current = '';
    setMatches(fallback); setSelected(null); setOnline(false); load();
    const timer = window.setInterval(load, 5000);
    return () => { active = false; window.clearInterval(timer); };
  }, [tournamentKey, fallback]);

  useEffect(() => {
    if (!selected?.slug) return undefined;
    let active = true;
    const loadDetail = async () => {
      try {
        const headers = detailEtag.current ? { 'If-None-Match': detailEtag.current } : {};
        const response = await fetch(`${API_URL}/match-center/matches/${encodeURIComponent(selected.slug)}`, { headers });
        if (response.status === 304) return;
        if (!response.ok) throw new Error();
        const data = await response.json();
        if (active && data.match) {
          detailEtag.current = response.headers.get('ETag') || '';
          setSelected(data.match);
        }
      } catch (_) { /* Keep the latest successfully loaded snapshot visible. */ }
    };
    detailEtag.current = '';
    loadDetail();
    const timer = window.setInterval(loadDetail, 5000);
    return () => { active = false; window.clearInterval(timer); };
    // Reload only when a different match is opened.
  }, [selected?.slug]); // eslint-disable-line react-hooks/exhaustive-deps

  if (selected) {
    return <MatchDetail match={selected} onBack={() => setSelected(null)} />;
  }
  const live = matches.find((match) => match.status === 'live');
  const rest = matches.filter((match) => match.slug !== live?.slug);
  const showPlayers = discipline === 'cs2';
  return <section className="mc-center">
    <header className="mc-head"><div><span className="fed-eyebrow">{T.tournamentMatches}</span><h2>{T.headline}</h2><p>{T.intro}</p></div><span className={`mc-connection ${online ? 'online' : 'demo'}`}><i />{online ? T.online : T.demo}</span></header>
    {showPlayers && <div className="mc-tabs" role="tablist" aria-label={L.sections}>{[['matches', L.matchesTab], ['players', L.playersTab]].map(([key, label]) => <button key={key} role="tab" aria-selected={view === key} className={view === key ? 'on' : ''} onClick={() => setView(key)}>{label}</button>)}</div>}
    {showPlayers && view === 'players' ? <TournamentPlayers tournamentKey={tournamentKey} /> : <>
      {live && <LiveSpotlight match={live} onOpen={setSelected} />}
      {rest.length > 0 && <div className="mc-schedule-head"><h3>{T.other}</h3><p>{T.otherHint}</p></div>}
      <div className="mc-match-grid">{rest.map((match) => <MatchCard key={match.slug} match={match} onOpen={setSelected} />)}</div>
      {!matches.length && <div className="mc-empty">{T.empty}</div>}
    </>}
  </section>;
}
